module.exports = __webpack_public_path__ + "img/425-467d51.png";